import { createRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { appLayoutRoute } from "@/routes/layout-routes";
import { CallbackLeadsScreen } from "@/app/CallbackLeads/Screens/CallbackLeadsScreen";

export const callbackLeadLists = ["due", "snoozed", "closed", "all"] as const;

export type CallbackLeadList = (typeof callbackLeadLists)[number];

const callbackLeadSearchParams = z.object({
  list: fallback(z.enum(callbackLeadLists), "due").default("due"),
});

export const callbackLeadsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/callbacks",
  component: CallbackLeadsScreen,
  validateSearch: zodValidator(callbackLeadSearchParams),
  head: () => ({
    meta: [
      {
        title: "Callbacks - Imoova Admin",
      },
      {
        name: "description",
        content: "Call back customers who did not finish their booking",
      },
    ],
  }),
});
